var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _circle, _circle2, _path19, _path20, _circle3, _circle4, _path21, _path22, _circle5, _circle6, _path23, _path24, _circle7, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHallPalace = function SvgHallPalace(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 414,
    height: 445,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7D4A2",
    stroke: "#000",
    d: "M69.092 88.767h425.896v5.781H69.092z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "M63.311 101.613H500.77v-7.067H63.311z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7D4A2",
    stroke: "#000",
    d: "M66.522 101.613h431.035v13.49H66.522z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "M45.324 128.594h473.432v-13.49H45.324z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7D4A2",
    stroke: "#000",
    d: "M48.536 128.594h467.008v7.066H48.536z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "M45.324 149.15h473.432v-13.49H45.324z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7D4A2",
    stroke: "#000",
    d: "M48.536 149.15h467.008v259.52H48.536z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3F8FF",
    stroke: "#BA9464",
    strokeWidth: 9,
    d: "M67.811 168.425h44.317v100.204H67.811V168.425ZM227.762 218.527c0-27.671 22.431-50.102 50.102-50.102s50.102 22.431 50.102 50.102v50.102H227.762zM67.811 290.478h44.317v100.204H67.811V290.478ZM227.762 290.478h100.204v100.20400000000001H227.762V290.478Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9CEC6",
    stroke: "#000",
    d: "M1 443.999h562.08v-35.33H1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE5C1",
    stroke: "#000",
    d: "M1 423.443h562.08v-14.775H1z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "M63.311 77.203H500.77v11.563H63.311z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "m283.003.759 185.809 114.664H97.194z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hall-palace_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7D4A2",
    d: "m283.003 12.805 147.105 90.575H135.899z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m283.003 12.805 147.105 90.575H135.899z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#hall-palace_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    d: "M283.003 27.74 392.85 94.547H173.157z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M283.003 27.74 392.85 94.547H173.157z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "M96.071 115.1h373.864v10.278H96.071z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7D4A2",
    stroke: "#000",
    d: "M110.204 131.161h345.599v-5.782H110.204z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    stroke: "#000",
    d: "M104.423 131.161h357.161v11.562H104.423zM130.76 151.074h28.265v257.593H130.76zM348.526 151.074h28.265v257.593h-28.265zM182.793 151.074h28.265v257.593h-28.265zM400.559 151.074h28.265v257.593h-28.265z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9CEC6",
    stroke: "#000",
    d: "M126.906 399.597h35.973v8.993h-35.973zM344.671 399.597h35.973v8.993h-35.973zM178.939 399.597h35.973v8.993h-35.973zM396.705 399.597h35.973v8.993h-35.973z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    fillRule: "evenodd",
    d: "M142.129 153.22c0 5.8-4.702 10.502-10.502 10.502s-10.502-4.702-10.502-10.502 4.702-10.502 10.502-10.502h26.532c5.8 0 10.501 4.702 10.501 10.502s-4.702 10.502-10.502 10.502-10.502-4.702-10.502-10.502q.001-.847.13-1.658h-5.787q.129.811.13 1.658",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M131.627 142.718v-.5zm26.532 0v-.5zm-10.373 8.844.494.078.092-.578h-.586zm-5.787 0v-.5h-.586l.092.578zm-10.372 12.66c6.076 0 11.002-4.926 11.002-11.002h-1c0 5.524-4.478 10.002-10.002 10.002zm-11.002-11.002c0 6.076 4.926 11.002 11.002 11.002v-1c-5.524 0-10.002-4.478-10.002-10.002zm11.002-11.002c-6.076 0-11.002 4.926-11.002 11.002h1c0-5.524 4.478-10.002 10.002-10.002zm0 0v1zm26.531 0h-26.531v1h26.531zm0 1h.001v-1h-.001zm.001 0c5.523 0 10.001 4.478 10.001 10.002h1c0-6.076-4.925-11.002-11.001-11.002zm10.001 10.002c0 5.524-4.478 10.002-10.002 10.002v1c6.077 0 11.002-4.926 11.002-11.002zm-10.002 10.002c-5.524 0-10.002-4.478-10.002-10.002h-1c0 6.076 4.926 11.002 11.002 11.002zm-10.002-10.002q.001-.807.124-1.58l-.988-.156a11 11 0 0 0-.136 1.736zm-6.157-1.158h5.787v-1h-5.787zm.63 1.158q-.001-.886-.136-1.736l-.988.156q.123.773.124 1.58z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 158.158,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.627,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    fillRule: "evenodd",
    d: "M359.895 153.22c0 5.8-4.702 10.502-10.502 10.502s-10.502-4.702-10.502-10.502 4.702-10.502 10.502-10.502h26.531c5.8 0 10.502 4.702 10.502 10.502s-4.702 10.502-10.502 10.502-10.502-4.702-10.502-10.502q.001-.847.13-1.658h-5.787q.129.811.13 1.658",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M349.393 142.718v-.5zm26.531 0v-.5zm-10.372 8.844.494.078.092-.578h-.586zm-5.787 0v-.5h-.586l.092.578zm-10.372 12.66c6.076 0 11.002-4.926 11.002-11.002h-1c0 5.524-4.478 10.002-10.002 10.002zm-11.002-11.002c0 6.076 4.925 11.002 11.002 11.002v-1c-5.524 0-10.002-4.478-10.002-10.002zm11.002-11.002c-6.077 0-11.002 4.926-11.002 11.002h1c0-5.524 4.478-10.002 10.002-10.002zm0 0v1zm26.531 0h-26.531v1h26.531zm0 1v-1zm0 0c5.524 0 10.002 4.478 10.002 10.002h1c0-6.076-4.925-11.002-11.002-11.002zm10.002 10.002c0 5.524-4.478 10.002-10.002 10.002v1c6.076 0 11.002-4.926 11.002-11.002zm-10.002 10.002c-5.524 0-10.002-4.478-10.002-10.002h-1c0 6.076 4.926 11.002 11.002 11.002zm-10.002-10.002q0-.807.124-1.58l-.988-.156a11 11 0 0 0-.136 1.736zm-6.157-1.158h5.787v-1h-5.787zm.63 1.158q-.001-.886-.136-1.736l-.988.156q.123.773.124 1.58z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.924,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 349.392,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    fillRule: "evenodd",
    d: "M194.162 153.22c0 5.8-4.702 10.502-10.502 10.502s-10.503-4.702-10.503-10.502 4.702-10.502 10.503-10.502h26.531c5.8 0 10.502 4.702 10.502 10.502s-4.702 10.502-10.502 10.502-10.502-4.702-10.502-10.502q0-.847.13-1.658h-5.787q.129.811.13 1.658",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M183.66 142.718v-.5zm26.531 0v-.5zm-10.372 8.844.494.078.092-.578h-.586zm-5.787 0v-.5h-.586l.092.578zm-10.372 12.66c6.076 0 11.002-4.926 11.002-11.002h-1c0 5.524-4.478 10.002-10.002 10.002zm-11.003-11.002c0 6.076 4.926 11.002 11.003 11.002v-1c-5.524 0-10.003-4.478-10.003-10.002zm11.003-11.002c-6.077 0-11.003 4.926-11.003 11.002h1c0-5.524 4.479-10.002 10.003-10.002zm0 0v1zm26.531 0H183.66v1h26.531zm0 1v-1zm0 0c5.524 0 10.002 4.478 10.002 10.002h1c0-6.076-4.926-11.002-11.002-11.002zm10.002 10.002c0 5.524-4.478 10.002-10.002 10.002v1c6.076 0 11.002-4.926 11.002-11.002zm-10.002 10.002c-5.524 0-10.002-4.478-10.002-10.002h-1c0 6.076 4.926 11.002 11.002 11.002zm-10.002-10.002q0-.807.124-1.58l-.988-.156a11 11 0 0 0-.136 1.736zm-6.157-1.158h5.787v-1h-5.787zm.63 1.158q-.001-.886-.137-1.736l-.987.156q.123.773.124 1.58z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210.191,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 183.66,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEEE0",
    fillRule: "evenodd",
    d: "M411.928 153.22c0 5.8-4.702 10.502-10.503 10.502-5.8 0-10.502-4.702-10.502-10.502s4.702-10.502 10.502-10.502h26.532c5.8 0 10.502 4.702 10.502 10.502s-4.702 10.502-10.502 10.502-10.502-4.702-10.502-10.502q0-.847.13-1.658h-5.788q.13.811.131 1.658",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M401.425 142.718v-.5zm26.532 0v-.5zm-10.372 8.844.494.078.091-.578h-.585zm-5.788 0v-.5h-.585l.092.578zm-10.372 12.66c6.077 0 11.003-4.926 11.003-11.002h-1c0 5.524-4.479 10.002-10.003 10.002zm-11.002-11.002c0 6.076 4.926 11.002 11.002 11.002v-1c-5.524 0-10.002-4.478-10.002-10.002zm11.002-11.002c-6.076 0-11.002 4.926-11.002 11.002h1c0-5.524 4.478-10.002 10.002-10.002zm0 0v1zm26.532 0h-26.532v1h26.532zm0 1v-1zm0 0c5.524 0 10.002 4.478 10.002 10.002h1c0-6.076-4.926-11.002-11.002-11.002zm10.002 10.002c0 5.524-4.478 10.002-10.002 10.002v1c6.076 0 11.002-4.926 11.002-11.002zm-10.002 10.002c-5.524 0-10.002-4.478-10.002-10.002h-1c0 6.076 4.926 11.002 11.002 11.002zm-10.002-10.002q0-.807.124-1.58l-.988-.156a11 11 0 0 0-.136 1.736zm-6.158-1.158h5.788v-1h-5.788zm.631 1.158q-.001-.886-.137-1.736l-.987.156q.123.773.124 1.58z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 401.426,
    cy: 153.222,
    r: 6.08,
    fill: "#D9CEC6",
    stroke: "#000"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#451D07",
    fillOpacity: 0.5,
    d: "M292.907 71.4q1.935 2.523.811 5.485-1.123 2.962-4.459 3.885a6.34 6.34 0 0 1-3.254.035q-1.66-.408-2.72-1.54-3.847 1.676-7.229-.165-3.381-1.84-4.064-5.984-1.683-.4-2.862-1.578-1.177-1.178-1.699-2.97-.837-2.877 1.332-5.39 2.168-2.511 5.032-2.183l3.353.397q.541-1.73 1.869-3.092a7.74 7.74 0 0 1 3.137-1.965l-.713-2.453q-.178-.612.116-1.128.294-.514.922-.688t1.156.113.706.9l.823 2.83q1.939.024 3.422.811 1.482.788 2.88 2.541l2.803-.776q.629-.174 1.156.113.528.287.706.9.178.614-.116 1.128-.294.515-.923.69l-2.513.695a7.7 7.7 0 0 1-.017 3.624 7.2 7.2 0 0 1-1.666 3.162zm-11.658 4.453a14.5 14.5 0 0 1-.503-2.537 13.3 13.3 0 0 1-.026-2.516 9.4 9.4 0 0 1-2.18 1.394q-1.22.567-2.504.82.536 1.84 1.931 2.6t3.282.239m-5.827-6.746q1.546-.428 2.622-1.133 1.074-.705 2.63-2.36l-6.486-.752q-1.566-.178-2.386.686t-.449 2.138q.357 1.226 1.343 1.565t2.726-.144m12.74 7.89q1.209-.336 1.718-1.368t-.139-1.822l-4.475-5.693a15.4 15.4 0 0 0-.548 3.414q-.069 1.65.288 2.876.453 1.557 1.248 2.229.796.671 1.908.363m.145-11.356q.346-.606.41-1.464a4.8 4.8 0 0 0-.183-1.708q-.44-1.51-1.756-2.266-1.317-.758-2.815-.342-.87.24-1.561.738t-1.072 1.164l4.264.654zM262.358 60.148c-.147.05-.343 0-.343-.201-.146-.555-.44-1.814.098-2.872s1.712-1.612 2.25-1.814c.147-.05.343 0 .343.202.195.554.44 1.813-.098 2.871s-1.712 1.613-2.25 1.814m-.392 2.922c.734-.604 1.713-.806 2.251-.856.195 0 .342.151.293.352-.147.555-.44 1.462-1.174 2.066-.734.605-1.712.806-2.25.857-.147 0-.245-.101-.293-.202-.098.101-.245.151-.392.05-.489-.302-1.418-1.058-1.81-2.166-.391-1.108-.097-2.267.098-2.77.049-.152.245-.253.44-.152.49.302 1.419 1.058 1.81 2.166.245.706.245 1.411.147 1.965.147-.453.44-.907.88-1.31m-2.299 4.837c.392.605.539 1.36.539 1.965.097-.454.244-1.008.635-1.511.587-.756 1.468-1.16 2.006-1.31.196-.05.342.1.342.251 0 .504-.097 1.512-.684 2.268-.587.806-1.468 1.159-2.006 1.31-.147.05-.293-.05-.342-.151-.049.15-.196.201-.343.15-.538-.2-1.614-.705-2.25-1.712-.636-.958-.587-2.167-.538-2.721 0-.201.196-.302.391-.252.538.252 1.615.756 2.25 1.713m-2.005 4.232c.538.05 1.712.252 2.592 1.058.539.454.832 1.058 1.028 1.562 0-.453 0-.907.195-1.41.343-.907 1.076-1.512 1.517-1.814.146-.101.391-.05.44.15.147.505.293 1.462-.049 2.369s-1.076 1.511-1.516 1.814a.4.4 0 0 1-.343 0c-.049.1-.146.15-.293.1-.587-.05-1.761-.252-2.593-1.058-.88-.806-1.174-1.914-1.272-2.468-.048-.202.098-.353.294-.303m2.788 5.442c.587-.101 1.957-.152 3.033.554.489.302.88.705 1.174 1.108a4 4 0 0 1-.343-1.562c0-1.26.685-2.368 1.028-2.871.097-.152.342-.152.44 0 .342.503 1.027 1.561 1.027 2.871 0 1.26-.685 2.368-1.027 2.872-.098.151-.343.151-.44 0l-.049-.05c0 .05.049.1.049.1.049.152-.049.353-.245.353-.587.05-1.957.151-3.033-.554-1.076-.655-1.663-1.864-1.858-2.469-.049-.151.048-.353.244-.353M301.915 60.148c.146.05.342 0 .342-.201.147-.555.44-1.814-.098-2.872s-1.712-1.612-2.25-1.814c-.147-.05-.342 0-.342.202-.196.554-.441 1.813.098 2.871.538 1.058 1.712 1.613 2.25 1.814m.391 2.922c-.734-.604-1.712-.806-2.25-.856-.196 0-.343.151-.294.352.147.555.441 1.462 1.174 2.066.734.605 1.712.806 2.25.857.147 0 .245-.101.294-.202.098.101.245.151.391.05.489-.302 1.419-1.058 1.81-2.166s.098-2.267-.098-2.77c-.049-.152-.244-.253-.44-.152-.489.302-1.418 1.058-1.81 2.166a4 4 0 0 0-.147 1.965c-.146-.453-.44-.907-.88-1.31m2.299 4.837c-.391.605-.538 1.36-.538 1.965-.098-.454-.245-1.008-.636-1.511-.587-.756-1.467-1.16-2.005-1.31a.268.268 0 0 0-.343.251c0 .504.098 1.512.685 2.268.587.806 1.467 1.159 2.005 1.31.147.05.294-.05.343-.151.049.15.195.201.342.15.538-.2 1.614-.705 2.25-1.712.636-.958.587-2.167.538-2.721 0-.201-.195-.302-.391-.252-.538.252-1.614.756-2.25 1.713m2.006 4.232c-.539.05-1.713.252-2.593 1.058-.538.454-.832 1.058-1.027 1.562 0-.453 0-.907-.196-1.41-.342-.907-1.076-1.512-1.516-1.814-.147-.101-.392-.05-.44.15-.147.505-.294 1.462.048 2.369.343.907 1.077 1.511 1.517 1.814.098.05.244.05.342 0 .049.1.147.15.294.1.587-.05 1.761-.252 2.592-1.058.881-.806 1.174-1.914 1.272-2.468.049-.202-.098-.353-.293-.303m-2.789 5.442c-.587-.101-1.956-.152-3.032.554-.49.302-.881.705-1.174 1.108a4.1 4.1 0 0 0 .342-1.562c0-1.26-.685-2.368-1.027-2.871-.098-.152-.343-.152-.44 0-.343.503-1.028 1.561-1.028 2.871 0 1.26.685 2.368 1.028 2.872.097.151.342.151.44 0l.049-.05c0 .05-.049.1-.049.1-.049.152.049.353.244.353.587.05 1.957.151 3.033-.554 1.076-.655 1.663-1.864 1.859-2.469.049-.151-.049-.353-.245-.353"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "hall-palace_svg__a",
    width: 297.74,
    height: 91.662,
    x: 134.134,
    y: 12.218,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_31324_1614"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hall-palace_svg__b",
    width: 223.261,
    height: 67.892,
    x: 171.372,
    y: 27.155,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_31324_1614"
  })))));
};
export default SvgHallPalace;